export const policies: { [key: string]: any } = {
  AL: {
    policy: {
      term_in_months: 6,
      coverages: {
        bodily_injury: {
          limit_key: 'fifty_one_hundred',
        },
        property_damage: {
          limit_key: 'one_hundred_thousand',
        },
        medical_payments: {
          limit_key: 'one_thousand',
        },
        uninsured_motorist_bodily_injury: {
          limit_key: 'fifty_one_hundred',
        },
        underinsured_motorist_bodily_injury: {
          limit_key: 'fifty_one_hundred',
        },
      },
      mailing_address: {
        line_one: '4512 12th Ave N',
        city: 'Birmingham',
        state: 'AL',
        zip_code: '35212',
      },
    },
  },
  AZ: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      property_damage: {
        limit_key: 'one_hundred_thousand',
      },
      medical_payments: {
        limit_key: 'two_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
    },
    mailing_address: {
      line_one: '12202 N 57th Way',
      city: 'Scottsdale',
      state: 'AZ',
      zip_code: '85254',
    },
  },
  CA: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      property_damage: {
        limit_key: 'five_thousand',
      },
      medical_payments: {
        limit_key: 'five_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
    },
    mailing_address: {
      line_one: '5109 GASLIGHT LN',
      city: 'CULVER CITY',
      state: 'CA',
      zip_code: '90230',
    },
  },
  GA: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'one_hundred_two_hundred',
      },
      property_damage: {
        limit_key: 'fifty_thousand',
      },
      medical_payments: {
        limit_key: 'one_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'one_hundred_three_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'one_hundred_three_hundred',
      },
      uninsured_motorist_property_damage: {
        limit_key: 'fifty_thousand_one_thousand',
      },
      added_on_uninsured: {
        waived: true,
      },
    },
    mailing_address: {
      line_one: '4520 E BROOKHAVEN DR NE',
      city: 'ATLANTA',
      state: 'GA',
      zip_code: '30319',
    },
  },
  IL: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'one_hundred_three_hundred',
      },
      property_damage: {
        limit_key: 'twenty_thousand',
      },
      medical_payments: {
        waived: true,
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'one_hundred_three_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'one_hundred_three_hundred',
      },
    },
    mailing_address: {
      line_one: '2311 CENTRAL ST',
      line_two: 'Apt 2',
      city: 'EVANSTON',
      state: 'IL',
      zip_code: '60201',
    },
  },
  IN: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      property_damage: {
        limit_key: 'twenty_five_thousand',
      },
      medical_payments: {
        limit_key: 'two_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'fifty_fifty',
      },
      uninsured_motorist_property_damage: {
        limit_key: 'fifty_thousand',
      },
    },
    mailing_address: {
      line_one: '19 W Peabody Ln',
      city: 'Clinton',
      state: 'IN',
      zip_code: '47842',
    },
  },
  KY: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'one_hundred_two_hundred',
      },
      property_damage: {
        limit_key: 'fifty_thousand',
      },
      medical_payments: {
        limit_key: 'one_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'one_hundred_three_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'one_hundred_three_hundred',
      },
      additional_personal_injury_protection: {
        package_key: 'apip_opt1',
      },
    },
    mailing_address: {
      line_one: '315 E Main St',
      city: 'Earlington',
      state: 'KY',
      zip_code: '42410',
    },
  },
  LA: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      property_damage: {
        limit_key: 'one_hundred_thousand',
      },
      medical_payments: {
        limit_key: 'one_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'one_hundred_three_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'one_hundred_three_hundred',
      },
    },
    mailing_address: {
      line_one: '1500 MCKEEN PL',
      line_two: 'Apt 2',
      city: 'MONROE',
      state: 'LA',
      zip_code: '71201',
    },
  },
  MD: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      property_damage: {
        limit_key: 'one_hundred_thousand',
      },
      medical_payments: {
        limit_key: 'two_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      uninsured_motorist_property_damage: {
        limit_key: 'fifteen_thousand',
      },
      personal_injury_protection: {
        package_key: 'opt_2',
      },
      enhanced_uninsured: {
        waived: false,
      },
      limited_pip: {
        waived: false,
      },
    },
    mailing_address: {
      line_one: '1107 Fuselage Ave',
      city: 'Baltimore',
      state: 'MD',
      zip_code: '21220',
    },
  },
  MO: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      property_damage: {
        limit_key: 'one_hundred_thousand',
      },
      medical_payments: {
        limit_key: 'two_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      uninsured_motorist_property_damage: {
        limit_key: 'twenty_five_thousand',
      },
    },
    mailing_address: {
      line_one: '156 Simpson Rd',
      city: 'Urbana',
      state: 'MO',
      zip_code: '65767',
    },
  },
  MS: {
    policy: {
      term_in_months: 6,
      coverages: {
        bodily_injury: {
          limit_key: 'fifty_one_hundred',
        },
        property_damage: {
          limit_key: 'one_hundred_thousand',
        },
        medical_payments: {
          limit_key: 'one_thousand',
        },
        uninsured_motorist_bodily_injury: {
          limit_key: 'fifty_one_hundred',
        },
        underinsured_motorist_bodily_injury: {
          limit_key: 'fifty_one_hundred',
        },
        uninsured_motorist_property_damage: {
          limit_key: 'one_hundred_thousand',
        },
      },
      mailing_address: {
        line_one: '115 Perkinston Silver Run Rd',
        city: 'Perkinston',
        state: 'MS',
        zip_code: '39573',
      },
    },
  },
  NE: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      property_damage: {
        limit_key: 'one_hundred_thousand',
      },
      personal_injury_protection: {
        package_key: 'mand_min',
      },
      medical_payments: {
        limit_key: 'one_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
    },
    mailing_address: {
      line_one: '5840 ADAMS ST',
      line_two: 'Apt 2',
      city: 'Lincoln',
      state: 'NE',
      zip_code: '68507',
    },
  },
  OH: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'three_hundred_five_hundred',
      },
      property_damage: {
        limit_key: 'one_hundred_thousand',
      },
      medical_payments: {
        limit_key: 'two_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'three_hundred_five_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'three_hundred_five_hundred',
      },
    },
    mailing_address: {
      line_one: '1316 Harpster Ave',
      city: 'Akron',
      state: 'OH',
      zip_code: '44314',
    },
  },
  OK: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      property_damage: {
        limit_key: 'one_hundred_thousand',
      },
      personal_injury_protection: {
        package_key: 'mand_min',
      },
      medical_payments: {
        limit_key: 'one_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
    },
    mailing_address: {
      line_one: '1600 nw 38th st',
      city: 'Oklahoma City',
      state: 'OK',
      zip_code: '73118',
    },
  },
  OR: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'twenty_five_fifty',
      },
      property_damage: {
        limit_key: 'twenty_thousand',
      },
      personal_injury_protection: {
        package_key: 'mand_min',
      },
      medical_payments: {
        waived: true,
      },
      uninsured_motorist_property_damage: {
        waived: true,
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'twenty_five_fifty',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'twenty_five_fifty',
      },
    },
    mailing_address: {
      line_one: '14579 SE Creekside Dr',
      city: 'Milwaukie',
      state: 'OR',
      zip_code: '97267',
    },
  },
  PA: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'twenty_five_fifty',
      },
      property_damage: {
        limit_key: 'five_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'twenty_five_fifty',
        stacked: true,
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'twenty_five_fifty',
        stacked: false,
      },
      first_party_benefits: {
        package_key: 'opt_ee',
      },
      limited_tort: {
        waived: false,
      },
      extraordinary_medical_benefit: {
        limit_key: 'one_million_one_hundred_thousand',
      },
    },

    mailing_address: {
      line_one: '526 Eagle Dr',
      city: 'East Stroudsburg',
      state: 'PA',
      zip_code: '18302',
    },
  },
  TX: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      property_damage: {
        limit_key: 'twenty_five_thousand',
      },
      personal_injury_protection: {
        package_key: 'mand_min',
      },
      medical_payments: {
        limit_key: 'one_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
    },
    mailing_address: {
      line_one: '7314 Birchtree Forest Dr',
      city: 'Houston',
      state: 'TX',
      zip_code: '77088',
    },
  },
  UT: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      property_damage: {
        limit_key: 'one_hundred_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
    },
    mailing_address: {
      line_one: '635 E CENTER ST',
      city: 'HEBER CITY',
      state: 'UT',
      zip_code: '84032',
    },
  },
  VA: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      property_damage: {
        limit_key: 'one_hundred_thousand',
      },
      personal_injury_protection: {
        package_key: 'mand_min',
      },
      medical_payments: {
        limit_key: 'one_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      uninsured_motorist_property_damage: {
        limit_key: 'one_hundred_thousand',
      },
    },
    mailing_address: {
      line_one: '7576 Pine Stake Rd',
      city: 'Culpeper',
      state: 'VA',
      zip_code: '22701',
    },
  },
  WI: {
    term_in_months: 6,
    coverages: {
      bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      property_damage: {
        limit_key: 'one_hundred_thousand',
      },
      medical_payments: {
        limit_key: 'two_thousand',
      },
      uninsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
      underinsured_motorist_bodily_injury: {
        limit_key: 'fifty_one_hundred',
      },
    },
    mailing_address: {
      line_one: '2600 W HIGH ST',
      line_two: 'Apt 206',
      city: 'RACINE',
      state: 'WI',
      zip_code: '53404',
    },
  },
  WV: {
    policy: {
      term_in_months: 6,
      coverages: {
        bodily_injury: {
          limit_key: 'fifty_one_hundred',
        },
        property_damage: {
          limit_key: 'one_hundred_thousand',
        },
        medical_payments: {
          waived: true,
        },
        uninsured_motorist_bodily_injury: {
          limit_key: 'fifty_one_hundred',
        },
        underinsured_motorist_bodily_injury: {
          limit_key: 'fifty_one_hundred',
        },
        uninsured_motorist_property_damage: {
          limit_key: 'fifty_thousand_three_hundred',
        },
        underinsured_motorist_property_damage: {
          limit_key: 'fifty_thousand_three_hundred',
        },
      },
      mailing_address: {
        line_one: '1004 Ridgemont Dr',
        city: 'Elkview',
        state: 'WV',
        zip_code: '25071',
      },
    },
  },
};
